import React from 'react';
import DateInput from '../../../../../../component/input/dateInput/DateInput';
import TimeInput from '../../../../../../component/input/dateInput/TimeInput';
import * as css from '../TicketValidity.css';

interface DateTimeInputPairProps {
    dateFieldName: string;
    timeFieldName: string;
    dateLabel: string;
    timeLabel: string;
    isEnabled: boolean;
}

function DateTimeInputPair({
    dateFieldName,
    timeFieldName,
    dateLabel,
    timeLabel,
    isEnabled
}: DateTimeInputPairProps) {
    return (
        <css.inputsRow>
            <css.dateTimeColumn>
                <DateInput
                    name={dateFieldName}
                    text={dateLabel}
                    readOnly={!isEnabled}
                    isFixed
                    className={!isEnabled ? 'disabled' : undefined}
                    icon="calendar" descText={undefined} onChange={undefined}                />
            </css.dateTimeColumn>
            <css.dateTimeColumn>
                <TimeInput
                    name={timeFieldName}
                    text={timeLabel}
                    readOnly={!isEnabled}
                    isTimestamp
                    isFixed
                    className={!isEnabled ? 'disabled' : undefined}
                    icon="hourglassOutline" descText={undefined} onChange={undefined}                />
            </css.dateTimeColumn>
        </css.inputsRow>
    );
}

export default DateTimeInputPair;